import { ExtractedResponse } from './applyRules'
import { FilterPagination, getConfig, Pagination } from './config'

export type PatientCreate = {
  name: string
  email?: string
  age: number
  imc: number
  sex: 'male' | 'female'
  pregnant?: 'pregnant' | 'not-pregnant'
  hasMenopause?: 'menopause' | 'not-menopause'
}

export type PatientEdit = PatientCreate & { _id: string }

export type Patient = {
  _id: string
  name: string
  email?: string
  age: number
  imc: number
  totalAnalysedExams: number
  lastAnalysedExam?: Date
  sex: 'male' | 'female'
  pregnant?: 'pregnant' | 'not-pregnant'
  hasMenopause?: 'menopause' | 'not-menopause'
}

export type PatientFilter = Partial<Patient & FilterPagination>

export type SaveIntoPatient = {
  extractorKey: string;
  patientId: string;
}

export type SaveIntoPatientResponse = {
  success: boolean
  patientId: string
  path: string
}

export type ExtractedResponseData = {
  data: ExtractedResponse
}

export type GetExamParams = {
  examId: string;
  patientId: string;
}

export type GraphExam = {
  [key: string]: {
    examId: string;
    name: string;
    result: number;
    unit: string;
  }
}

export const saveExam = async (params: SaveIntoPatient): Promise<SaveIntoPatientResponse> => {
  const config = getConfig()

  const response = await config.axios.post<SaveIntoPatientResponse>(
    `${config.API_URL}/patients/save-applied-rules`,
    params
  )

  return response.data
}

export const create = async (params: PatientCreate): Promise<Patient> => {
  const config = getConfig()

  const response = await config.axios.post<Patient>(
    `${config.API_URL}/patients`,
    params
  )

  return response.data
}

export const update = async (params: PatientEdit): Promise<Patient> => {
  const config = getConfig()

  const response = await config.axios.put<Patient>(
    `${config.API_URL}/patients/${params._id}`,
    params
  )

  return response.data
}

export const get = async (params?: PatientFilter): Promise<Pagination<Patient>> => {
  const config = getConfig()

  const response = await config.axios.get<Pagination<Patient>>(
    `${config.API_URL}/patients`,
    { params }
  )

  return response.data
}

export const getOne = async (patientId: string): Promise<Patient> => {
  const config = getConfig()

  const response = await config.axios.get<Patient>(
    `${config.API_URL}/patients/${patientId}`
  )

  return response.data
}

export const getLastExtraction = async (patientId: string): Promise<ExtractedResponse> => {
  const config = getConfig()

  const response = await config.axios.get<ExtractedResponseData>(
    `${config.API_URL}/patients/${patientId}/last-extraction`
  )

  return response.data.data
}

export const getExam = async (params: GetExamParams): Promise<GraphExam> => {
  const config = getConfig()

  const response = await config.axios.get<GraphExam>(
    `${config.API_URL}/patients/${params.patientId}/exams/${params.examId}`
  )

  return response.data
}
